/* Signature Pergolas — load-more pagination (DL-901/901b, design screen 11b).
   Serves both the collection grid (.sp-pager/.sp-cgrid) and the search results
   page (Dawn .pagination-wrapper + data-sp-loadmore-scope/-grid attributes).
   Progressive enhancement only: with JS disabled this file never runs and the
   numbered pagination (real ?page=N links) works exactly as before. With JS,
   the pager is hidden, the load-more control is revealed, and clicking it
   fetches the next page of the same section via the Section Rendering API
   (the button's href already carries every filter/sort/query param) and
   appends the new cards to the grid. Any fetch failure falls back to plain
   navigation of the button's real link. */
(function () {
  'use strict';

  function init(block) {
    if (block.dataset.spLoadmoreInit) return;
    block.dataset.spLoadmoreInit = 'true';

    var scope = block.closest('[data-sp-loadmore-scope]') || block.closest('.sp-cl__main') || document;
    var grid = scope.querySelector('[data-sp-loadmore-grid]') || scope.querySelector('.sp-cgrid');
    if (!grid) return;

    scope.querySelectorAll('.sp-pager, .pagination-wrapper').forEach(function (pager) {
      pager.classList.add('sp-pager--off');
    });
    block.classList.add('is-enhanced');
    updateCount(block, grid);

    block.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sp-loadmore-btn]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      loadNext(block, grid, btn);
    });
  }

  /* Count what is actually in the grid rather than trusting the server's
     cumulative figure, so a deep link straight to ?page=3 still reads true. */
  function updateCount(block, grid) {
    var count = block.querySelector('[data-sp-loadmore-count]');
    if (!count) return;
    count.textContent = 'Showing ' + grid.children.length + ' of ' + block.dataset.total;
  }

  function loadNext(block, grid, btn) {
    var url = btn.href + (btn.href.indexOf('?') > -1 ? '&' : '?') +
      'section_id=' + encodeURIComponent(block.dataset.sectionId);
    var label = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Loading...';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-sp-loadmore-grid]') || doc.querySelector('.sp-cgrid');
        var newBlock = doc.querySelector('[data-sp-loadmore]');
        if (!newGrid || !newBlock) throw new Error('Unexpected section response');

        while (newGrid.firstElementChild) {
          var child = newGrid.firstElementChild;
          /* Appended nodes are never seen by the theme's scroll-reveal
             observer, so its classes would leave them stuck invisible. */
          child.classList.remove('scroll-trigger', 'animate--slide-in');
          child.removeAttribute('data-cascade');
          child.querySelectorAll('.scroll-trigger').forEach(function (el) {
            el.classList.remove('scroll-trigger', 'animate--slide-in');
          });
          grid.appendChild(child);
        }

        var newBtn = newBlock.querySelector('[data-sp-loadmore-btn]');
        if (newBtn) {
          btn.href = newBtn.getAttribute('href');
          btn.textContent = label;
          btn.removeAttribute('aria-disabled');
        } else {
          btn.remove();
        }
        if (newBlock.dataset.total) block.dataset.total = newBlock.dataset.total;
        updateCount(block, grid);
      })
      .catch(function () {
        window.location.href = btn.href;
      });
  }

  function boot() {
    document.querySelectorAll('[data-sp-loadmore]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
